export default "__VITE_ASSET__165b365e__"